const PaymentMethodsFooter = () => {
  return (
    <div className="flex flex-col items-center space-y-4">
      <h3 className="text-lg font-semibold text-foreground">Formas de Pagamento</h3>
      
      {/* Individual payment method logos */}
      <div className="flex items-center justify-center gap-2 flex-nowrap">
        <img 
          src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Bandeiras/pix.webp" 
          alt="PIX" 
          className="h-5 md:h-6 w-auto max-w-[40px] object-contain"
          loading="lazy"
        />
        <img 
          src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Bandeiras/Visa_Logo.png" 
          alt="Visa" 
          className="h-5 md:h-6 w-auto max-w-[40px] object-contain"
          loading="lazy"
        />
        <img 
          src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Bandeiras/Mastercard-logo.png" 
          alt="Mastercard" 
          className="h-5 md:h-6 w-auto max-w-[40px] object-contain"
          loading="lazy"
        />
        <img 
          src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Bandeiras/american%20express.png" 
          alt="American Express" 
          className="h-5 md:h-6 w-auto max-w-[40px] object-contain"
          loading="lazy"
        />
        <img 
          src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Bandeiras/Hipercard_logo.svg.png" 
          alt="Hipercard" 
          className="h-5 md:h-6 w-auto max-w-[40px] object-contain"
          loading="lazy"
        />
      </div>

      
      {/* Security logos */}
      <div className="flex items-center space-x-4">
        <img 
          src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Bandeiras/Pagbank.png" 
          alt="PagBank - Processamento seguro de pagamentos" 
          className="h-6 md:h-7 w-auto object-contain"
          loading="lazy"
        />
        <img 
          src="https://qfozcnxbtjjmidhjdepc.supabase.co/storage/v1/object/public/Bandeiras/PCI.png" 
          alt="PCI DSS Compliant - Certificação de segurança" 
          className="h-6 md:h-7 w-auto object-contain"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default PaymentMethodsFooter;